import React from 'react';
import Icon from './Icon';

/* Figma asset: Radio component */
export default function RadioButton({ checked, onChange, label, name, value, className = '' }) {
  return (
    <label className={`flex items-center gap-2.5 cursor-pointer select-none ${className}`}>
      <Icon
        name={checked ? 'radio-on' : 'radio-off'}
        size={24}
        className={checked ? 'text-orange-500' : 'text-mono-400'}
      />
      <span className="text-2sm font-medium text-mono-900">{label}</span>
      <input type="radio" name={name} value={value} checked={checked} onChange={onChange} className="sr-only" />
    </label>
  );
}
